import { render, staticRenderFns } from "./ViStudentSummary.vue?vue&type=template&id=97b07248&scoped=true"
import script from "./ViStudentSummary.vue?vue&type=script&lang=js"
export * from "./ViStudentSummary.vue?vue&type=script&lang=js"
import style0 from "./ViStudentSummary.vue?vue&type=style&index=0&id=97b07248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b07248",
  null
  
)

export default component.exports